import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Backdrop from "@mui/material/Backdrop";
import { deactivateUser, activateUser } from "../../Api";
import toast from "react-hot-toast";

const ResetDeactivate = ({ modalType, user, refreshData,token }) => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "#fcebbb",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };

  const handleDeactivation = async (userid) => {
    let success, error;
    if (modalType === "Deactivate") {
      ({error}=await deactivateUser(userid, token));
    } else if (modalType === "Activate") {
      ({error}=await activateUser(userid, token));
    }
    if(error){
      toast.error(error)
    }
    setOpen(false);
    await refreshData();
  }

  return (
    <div>
      <div onClick={handleOpen}>{modalType}</div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={open}>
          <Box sx={style}>
            <p className="text-center m-2 font-semibold text-lg">{modalType}</p>
            <p className="text-center m-2 text-sm ">
              {modalType === "Reset Password" ? (
                <>
                  Are you sure you want to reset the password for{" "}
                  <span className="cursor-pointer text-sky-700 underline">
                    {user.email}
                  </span>
                  ? Once reset, the user can login using “pass@123”.
                </>
              ) : modalType === "Deactivate" ? (
                <>
                  Are you sure you want to deactivate{" "}
                  <span className="cursor-pointer text-sky-700 underline">
                    {user.email}
                  </span>
                  ? Once deactivated, the user will not be able to login.
                </>
              ) : (
                <>
                  Are you sure you want to activate{" "}
                  <span className="cursor-pointer text-sky-700 underline">
                    {user.email}
                  </span>
                  ? Once activated, the user will regain access to the application.
                </>
              )}

            </p>
            <div className=" flex justify-evenly items-center my-4">
              <Button
                onClick={() => handleDeactivation(user._id)}
                variant="contained"
                color={modalType === "Deactivate" ? "error" : "success"}
              >
                {modalType === "Reset Password"
                  ? "Reset"
                  : modalType === "Deactivate"
                    ? "Deactivate"
                    : "Activate"}
              </Button>

              <Button onClick={handleClose} variant="text">
                {" "}
                Cancel{" "}
              </Button>
            </div>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}

export default ResetDeactivate